import { useWindowDimensions } from 'react-native';

import { Box } from '@/components/lib/components/Box';
import { GlowShape } from '@/feature/promohub/components/OvalGlow';
import { designSystem } from '@/styles/styles';

export const CardShadow = () => {
    const { width } = useWindowDimensions();

    return (
        <Box height={16} width={'100%'} position={'absolute'} overflow={'hidden'} borderRadius={'r20'} top={4}>
            <GlowShape
                x={0}
                y={8}
                width={width}
                height={16}
                color={designSystem.colors.neutralBlack}
                opacity={0.4}
                blur={8}
                shape={'rect'}
            />
        </Box>
    );
};
